import template from './employee_role_list.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportEmployeeRoleListViewModel
{
	constructor(page)
	{
		this.page = page;
		this.employee_role_list = ko.observableArray();
		this.access_roles = ko.observableArray();
		this.role_name = ko.observable('admin');
		this.loader = ko.observable(false);
	}

	show_report_help()
	{
		Grape.dialog.open('EmployeesWithRolesHelp', { employee_id: this.page.bindings.id });
	}
}

class ReportEmployeeRoleListPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportEmployeeRoleListViewModel(this);
		this.viewModel.role_name.subscribe(() => this.updateData());
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('EmployeeWithRolesList'))
			return;

		document.title = tr('Employees With Roles');
		window.current_page_title(tr('Employees With Roles'));

		this.viewModel.access_roles(await Utils.getGrapeListAccessRoles());
	}

	async updateData()
	{
		this.viewModel.loader(true);
		try
		{
			let res = await Grape.fetches.postJSON('/employee/get_employees_with_role', { 'role': this.viewModel.role_name() });
			if (res.status === 'OK' && res.employees_with_role !== null)
				this.viewModel.employee_role_list(res.employees_with_role);
			else
				this.viewModel.employee_role_list.removeAll();
		} catch (err) {
			console.error(err);
		}

		this.viewModel.loader(false);
	};
}

export default {
	route: '[/]general/employee_role_list',
	page_class: ReportEmployeeRoleListPage,
	template: template,
	template_filename: 'translation/employee_role_list'
};
